import { StateNode, TLEventHandlers, TLPointerEventInfo } from '@tldraw/tldraw'
import { setMaskingShapeId } from 'components/VisualStudioPlayground/VisualEditor/helpers'

type PointingMaskHandleInfo = TLPointerEventInfo & {
  target: 'selection'
} & {
  onInteractionEnd?: string
}

export class PointingMaskHandle extends StateNode {
  static override id = 'pointing_mask_handle'

  private info = {} as PointingMaskHandleInfo

  override onEnter = (info: PointingMaskHandleInfo) => {
    this.info = info
    const selectedShape = this.editor.getSelectedShapes()[0]
    if (!selectedShape) return
  }

  override onExit = () => {
    this.editor.updateInstanceState({ cursor: { type: 'default', rotation: 0 } }, { ephemeral: true })
  }

  override onPointerMove: TLEventHandlers['onPointerMove'] = () => {
    const isDragging = this.editor.inputs.isDragging

    if (isDragging) {
      this.parent.transition('masking', {
        ...this.info,
        onInteractionEnd: this.info.onInteractionEnd,
      })
    }
  }

  override onPointerUp: TLEventHandlers['onPointerUp'] = () => {
    if (this.info.onInteractionEnd) {
      this.editor.setCurrentTool(this.info.onInteractionEnd, this.info)
    } else {
      setMaskingShapeId(this.editor, null)
      this.parent.transition('idle')
    }
  }

  override onCancel: TLEventHandlers['onCancel'] = () => {
    this.cancel()
  }

  override onComplete: TLEventHandlers['onComplete'] = () => {
    this.cancel()
  }

  override onInterrupt = () => {
    this.cancel()
  }

  private cancel() {
    if (this.info.onInteractionEnd) {
      this.editor.setCurrentTool(this.info.onInteractionEnd, this.info)
    } else {
      setMaskingShapeId(this.editor, null)
      this.parent.transition('idle')
    }
  }
}
